import { Privilege } from "../../types/persons/privilege";
import * as types from "../actions/actionTypes";
import intialState from "./initialState";

const handles = {
  [types.NOT_AUTHENTICATED]: (state) => ({
    ...state,
    hasAuthenticated: false,
    loading: false,
  }),

  [types.BEGIN_LOGIN]: (state) => ({ ...state, error: null }),
  [types.LOGIN_FULFILLED]: (state) => ({
    ...state,
    loading: false,
    hasAuthenticated: true,
  }),
  [types.LOGIN_REJECTED]: (state, message) => ({
    ...state,
    loading: false,
    hasAuthenticated: false,
  }),
  [types.AUTH_LOGOUT_FULFILLED]: (state) => ({
    ...state,
    hasAuthenticated: false,
  }),
  [types.PERSONS_GET_SELF_REJECTED]: (state, error) => ({
    ...state,
    loading: false,
    hasAuthenticated: false,
    error,
  }),
  [types.PERSONS_GET_SELF_FULFILLED]: (state, { person, associationId }) => ({
    ...state,
    hasAuthenticated: true,
    loading: false,
    error: null,
    role: person.associations.reduce((prev, a) => prev | a.role, 0),
    privilege: person.associations.reduce(
      (prev, a) => prev | a.privilege,
      Privilege.none,
    ),
    adminAssociation: associationId,
  }),
};

export default function authenticationReducer(
  state = intialState.auth,
  action,
) {
  return action.type && action.type in handles
    ? handles[action.type](state, action.payload)
    : state;
}
